import { toMoney } from "shared/utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { Section } from "views/applications-id-report/components/Section";
import { Stat } from "views/applications-id-report/components/Stat";
import { Asset } from "shared/app/IdentityVerificationReport/types";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import { AssetItem } from "views/applications-id-report/components/SmartRender/AssetItem";

export const HousingAssistanceSlice = ({
  assets,
  amountCents,
  incomeId
}: {
  assets: Asset[];
  amountCents: number;
  incomeId?: number;
}) => (
  <Section
    maxWidth="1000px"
    sectionTitle="Housing assistance"
    data-income-id={incomeId}
  >
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat
          title="Monthly assistance amount"
          value={toMoney(amountCents / 100)}
        />
      </div>
    </div>

    <ContentTitle title="Vouchers" contentClassName="space-y-3">
      {assets.length > 0 ? (
        <>
          <div className="flex items-center gap-4">
            <InfoIcon className="text-warning-500 h-5" />
            <p className="text-content-400 font-medium">
              Fraud check not available for vouchers. Please manually review the
              documents
            </p>
          </div>
          {assets.map((asset, aIdx) => (
            <AssetItem
              key={aIdx}
              url={asset.asset?.url || ""}
              content_type={asset.asset?.content_type || ""}
              assetName={asset.asset?.filename || "Voucher document"}
            />
          ))}
        </>
      ) : (
        <p className="text-base text-content-500">No vouchers uploaded</p>
      )}
    </ContentTitle>
  </Section>
);
